// extracted by mini-css-extract-plugin
export var logo = "_k7-2";
export var logoWrapper = "_k7-1";
export var strip = "_k7-0";